export const SENTRY_DSN =
	"https://8af309f992412c9cf98314fd7f99f52f@o4508661293056000.ingest.us.sentry.io/4509832661303296";

export const DOMAIN_ENV_MAP: Record<string, "SANDBOX" | "STAGE" | "PROD"> = {
	"sandbox-kashu.tabpoint.us": "SANDBOX",
	"stage-kashu.tabpoint.us": "STAGE",
	"app.kashupay.com": "PROD",
	"app.payova.biz": "PROD",
	"kashulabs.softpoint.io": "PROD",
	"k-kashulabs.softpoint.io": "PROD",
};

export const EXCLUDED_API_PATHS: RegExp[] = [/\/auth\/guests\b/];
